<template>
    <div>
        <div>
            <p class="text-white text-4xl p-4 w-5 h-5 rounded-full mx-auto mb-8"
                :class="{'bg-room-green': !isOccupied, 'bg-room-red': isOccupied}"></p>
            <p class="text-white text-center mb-3">Ad hoc</p>
            <div v-show="!is_loading">
                <div v-if="!availability.is_occupied" @click="create(availability)" class="text-white w-40 py-2 rounded-full bg-room-grey text-center"> Raum reservieren
                </div>
            </div>
            <div v-show="!is_loading">
                <div v-if="availability.is_occupied" class="text-white w-40 py-2 rounded-full bg-room-grey text-center"> Reserviert
                </div>
            </div>
            <div v-show="is_loading">
                <div class="text-white w-36 py-2 rounded-full bg-room-grey text-center"> Lädt ...
                </div>
            </div>
        </div>
    </div>
  
</template>

<script>

import Loading from "./UI/Loading";

export default {
    name: "ConferenceRoomScreenTime",

    components: {Loading},


    data: () => ({
        is_loading: false,

    }),

     props: ['availability', 'id', 'isOccupied'],

    methods: {
        create(item) {
                this.is_loading = true;
                const [hour, minute] = item.time.split(':');
                const today = (new Date).toISOString().substring(0,10);
                window.axios.post('/panel/conference_rooms', {
                    start: today + ' ' + item.time,
                    end: today + ' ' + (minute === '30' ? ((parseInt(hour)+1) + ':00') : (hour + ':30')),
                    comment: 'Displaybuchung',
                    conference_room_id: this.id,
                }).then(() => {
                    this.is_loading = false;
                    this.availability.is_occupied = true;
                    this.$emit('created');
                }).catch(error => {
                    this.$root.$emit('error', error);
                })
            }
        }

}

</script>


<style>

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

.scrollbar-hide {
    -ms-overflow-style: none; 
    scrollbar-width: none;  
}

</style>